var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHappyEmojy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-38-happy_emojy",
    "data-name": "icon-38-happy emojy",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1537",
    "data-name": "Rectangle 1537",
    width: 38,
    height: 38,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "happy",
    d: "M11.762.531A15.864,15.864,0,1,1,2.14,7.921,15.864,15.864,0,0,1,11.762.531Zm-3.852,17.6a9.805,9.805,0,0,0,2.152,2.064,10.422,10.422,0,0,0,6.084,1.832,9.818,9.818,0,0,0,5.875-1.992,8.66,8.66,0,0,0,1.827-1.915.057.057,0,0,1,.077-.015l.6.591a.054.054,0,0,1,0,.07,11.217,11.217,0,0,1-3.432,3.7,9.212,9.212,0,0,1-4.9,1.548,9.5,9.5,0,0,1-5.039-1.355A12.257,12.257,0,0,1,7.2,18.8a.059.059,0,0,1,0-.07l.614-.609a.057.057,0,0,1,.077,0h0Zm11.772-9.4c1.048,0,1.9,1.231,1.9,2.748s-.849,2.746-1.9,2.746-1.9-1.231-1.9-2.746S18.633,8.734,19.681,8.734Zm-7.633,0c1.048,0,1.9,1.231,1.9,2.748s-.849,2.746-1.9,2.746-1.9-1.231-1.9-2.746.849-2.748,1.9-2.748Zm10.863-5.1a14.1,14.1,0,1,0,6.562,8.556,14.1,14.1,0,0,0-6.562-8.556Z",
    transform: "translate(2.985 3.015)",
    fill: "#1dbbbe"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyEmojy);
export default __webpack_public_path__ + "static/media/happy-emojy.7939c64cfdb4ad88fce51b098ce1f9d9.svg";
export { ForwardRef as ReactComponent };